import {
    Users,
    Zap,
    Filter,
    BarChart3,
    Compass,
} from "lucide-react";
import { Reveal } from "./Reveal";

const outcomes = [
    { icon: Users, label: "More qualified enquiries" },
    { icon: Zap, label: "Faster lead response" },
    { icon: Filter, label: "Fewer wasted leads" },
    { icon: BarChart3, label: "Better visibility of marketing performance" },
    { icon: Compass, label: "Clearer reinvestment decisions" },
];

export const Outcomes = () => (
    <section
        id="outcomes"
        data-testid="outcomes-section"
        className="scroll-mt-16 bg-white py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2">
                <Reveal>
                    <div className="fp-card-shadow overflow-hidden rounded-3xl border border-gray-100">
                        <img
                            src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzkxNzM1MDgyfDA&ixlib=rb-4.1.0&q=85&w=1200"
                            alt="Business owners reviewing marketing performance together"
                            className="h-[320px] w-full object-cover sm:h-[420px]"
                            loading="lazy"
                        />
                    </div>
                </Reveal>
                <div>
                    <Reveal>
                        <p className="text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                            Outcomes
                        </p>
                        <h2 className="mt-3 text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                            Built around commercial outcomes.
                        </h2>
                    </Reveal>
                    <ul className="mt-10 space-y-5">
                        {outcomes.map((o, i) => (
                            <Reveal key={o.label} delay={i * 0.07}>
                                <li
                                    data-testid={`outcome-item-${i}`}
                                    className="flex items-center gap-4"
                                >
                                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#2563EB]/10">
                                        <o.icon className="h-5 w-5 text-[#2563EB]" />
                                    </span>
                                    <span className="text-base font-medium text-[#0B1F44] lg:text-lg">
                                        {o.label}
                                    </span>
                                </li>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </section>
);
